import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { bindActionCreators } from 'redux';
import FlashMessageContainer from '../containers/FlashMessage/FlashMessageContainer';
import Home from './Home';
import '../contents/css/App.css';
import '../contents/css/dashboard.css';
import { idleTimer } from '../utils/IdleTimer';
import DefaultPage from './auth/DefaultPage';
import ActivityIndicator from './layout/ActivityIndicator';
import { session } from '../Service/APIService';

const checkAuth = () => {
  const token = session.client();
  if (token === null) {
    return false;
  }
  idleTimer(); // start timer
  return true;
};

const AuthRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      checkAuth() ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: '/login' }} />
      )
    }
  />
);

class App extends Component {
  render() {
    return (
      <div>
        <ToastContainer />
        <FlashMessageContainer />
        <Router>
          <Switch>
            <Route
              path="/"
              exact
              component={() => <DefaultPage pageFlag={true} />}
            />
            <Route
              path="/login"
              component={() => <DefaultPage pageFlag={true} />}
            />
            <Route
              path="/forgotpassword"
              component={() => <DefaultPage pageFlag={false} />}
            />
            {/* <Route path="/network" component={NetworkGraph} /> */}
            <AuthRoute name="Home" component={Home} />
          </Switch>
        </Router>
        <ActivityIndicator isLoading={this.props.loader.isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loader: state.ActivityIndicatorReducer,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(App);
